import {
    Modal,
    mergeStyleSets,
    getTheme,
    FontWeights,
    IconButton,
    TextField,
    ShimmeredDetailsList,
    SelectionMode
} from "@fluentui/react";
import React, { useEffect, useRef, useState } from 'react';
import useOnClickOutside from '../../../hooks/useOutsideClick';
import useComments from "../../../hooks/useComments";
import { toast } from "react-toastify";
import { commentsColumns, onRenderColumns } from '../../Content/InvoiceTable/utils';
import { useParams } from 'react-router';
import { useQueryClient } from 'react-query';

const Comments = ({ showComment, setShowComment, invoiceRecord }) => {
    const { id } = useParams();
    const [page, setPage] = React.useState(1);
    const [sort, setSort] = React.useState([]);
    const ref = useRef();
    const queryClient = useQueryClient();
    const {
        createMutation,
        data: list,
        isLoading: isLoadingList
    } = useComments({
        id,
        invoiceId: invoiceRecord.id,
        page,
        enabled: true,
        sort,
        searchData: {},
    });
    const theme = getTheme()
    const [disabled, setDisabled] = useState(false);
    const [comment, setComment] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const contentStyles = mergeStyleSets({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
            width: 500
        },
        header: [
            {
                flex: '1 1 auto',
                borderTop: `4px solid rgb(79, 82, 145)`,
                color: theme.palette.neutralPrimary,
                display: 'flex',
                alignItems: 'center',
                fontWeight: FontWeights.semibold,
                padding: '12px 12px 0px 24px'
            }
        ],
        body: {
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            overflowY: 'hidden',
            selectors: {
                p: { margin: '14px 0' },
                'p:first-child': { marginTop: 0 },
                'p:last-child': { marginBottom: 0 }
            }
        },
        footer: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 24px',
            margin: 'auto',
            marginBottom: 4
        },
        button: {
            width: 'auto',
        },
        cancel: {
            width: 'auto',
            backgroundColor: 'transparent',
            color: '65224'
        }
    });
    const iconButtonStyles = {
        root: {
            color: theme.palette.neutralPrimary,
            marginLeft: 'auto',
            marginTop: '4px',
            marginBottom: '4px',
        },
        rootHovered: {
            color: theme.palette.neutralDark
        }
    };
    useEffect(() => {
        if (!showComment) {
            setComment('');
            setErrorMessage('')
        }
    }, [showComment])



    useOnClickOutside(ref, () => setShowProfile(false));
    const handleSubmit = () => {
        if (!comment) {
            setErrorMessage("Comment Required")
            return
        }
        setErrorMessage("");
        setDisabled(true);
        createMutation.mutate(comment, {
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: ["GET-COMMENTS"],
                    refetchType: "all",
                });
                setDisabled(false);
                setComment('');
                toast.success("Comment submitted successfully");

            },
            onError: (error) => {
                setDisabled(false);
                toast.error(error.message || "Something went wrong in  comment submission")
            }
        });
    };

    return (
        <div>
            {showComment &&
                <Modal
                    titleAriaId="Add Comment"
                    isOpen={showComment}
                    onDismiss={() => {
                        setShowComment(false)
                    }}
                    isBlocking={false}
                    containerClassName={contentStyles.container}
                >
                    <div className={contentStyles.header}>
                        <h5 id="Comment">Add Comment</h5>
                        <IconButton
                            styles={iconButtonStyles}
                            iconProps={{ iconName: 'Cancel' }}
                            ariaLabel="Close popup modal"
                            onClick={() => {
                                setShowComment(false)
                            }}
                        />
                    </div>
                    <div className={contentStyles.body}>

                        <div className='d-flex  w-100 align-items-center justify-content-between'>
                            <TextField

                                required={true}
                                label="Comment"
                                name="Comment"
                                value={comment}
                                className="CommentBox"
                                errorMessage={errorMessage && errorMessage}
                                rules={{ required: "This field is required" }}
                                onChange={(e, val) =>
                                    setComment(val)
                                }
                                resizable
                                multiline
                            />
                            <div className='mx-1'>
                                <IconButton
                                    styles={iconButtonStyles}
                                    iconProps={{ iconName: 'Send' }}
                                    ariaLabel="Close popup modal"
                                    onClick={() => {
                                        handleSubmit()
                                    }}
                                />
                            </div>
                        </div>

                    </div>

                    <div style={{ marginLeft: 16 }}>
                        <ShimmeredDetailsList
                            columns={commentsColumns({
                                onEditClick: () => { },
                                isDetail: true,
                                onDownLoadClick: () => { },
                                onPaymentClick: () => { },
                            }).filter((i) => i.key != "Action")}
                            items={list || []}
                            enableShimmer={isLoadingList}
                            onRenderItemColumn={(item, index, column) => {
                                return onRenderColumns(item, index, column, [], true);
                            }}
                            selectionMode={SelectionMode.none}
                        ></ShimmeredDetailsList>
                    </div>
                </Modal>
            }
        </div>
    );
};

export default Comments;
